/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { toMoneyString } from '@finbeat/react-toolkit';
import { useTranslation } from 'react-i18next';

type MoneyProps = { value?: string | number | null; nullable?: boolean | null };

const Money = ({ value, nullable }: MoneyProps) => {
    const { i18n } = useTranslation();
    return (
        <>{nullable && value == null ? null : toMoneyString(value?.toString(), i18n.language)}</>
    );
};

export default Money;
